import React, { useState } from "react";
import {
  Avatar,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TableCell,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { Delete, Edit } from "@mui/icons-material";
import { CONSTANTS } from "../../common/constant";

const { CANCEL_BUTTON, SAVE_BUTTON } = CONSTANTS;

const AuthorListing = ({
  index,
  editedAuthor,
  englishName,
  hindiName,
  imageUrl,
  inputChange,
  editClick,
  saveClick,
  deleteClick,
  disablePrimary = null,
}) => {
  const [isModalOpen, setModalOpen] = useState(false);
  const [errors, setErrors] = useState({});

  const openEditModal = () => {
    editClick(index);
    setModalOpen(true);
    setErrors({});
  };

  const closeEditModal = () => {
    setModalOpen(false);
  };

  return (
    <TableRow>
      <TableCell>
        <Box>
          <Avatar
            sx={{ width: 48, height: 48 }}
            src={imageUrl}
            alt={englishName}
          />
        </Box>
      </TableCell>
      <TableCell>
        <Typography>{englishName}</Typography>
      </TableCell>
      <TableCell>
        <Typography>{hindiName}</Typography>
      </TableCell>
      <TableCell>
        <>
          <IconButton aria-label="edit" color="primary" onClick={openEditModal}>
            <Edit />
          </IconButton>
          <IconButton aria-label="delete" color="error" onClick={deleteClick}>
            <Delete />
          </IconButton>
        </>
        <Dialog open={isModalOpen} onClose={closeEditModal}>
          <DialogTitle>{"Edit Author Details"}</DialogTitle>
          <DialogContent>
            <TextField
              fullWidth
              margin="dense"
              label="English Name"
              name="en"
              value={editedAuthor?.name?.en || ""}
              onChange={inputChange}
              error={!!errors?.name?.en}
              helperText={errors?.name?.en}
            />
            <TextField
              fullWidth
              margin="dense"
              label="Hindi Name"
              name="hi"
              value={editedAuthor?.name?.hi || ""}
              onChange={inputChange}
              error={!!errors?.name?.hi}
              helperText={errors?.name?.hi}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={closeEditModal}>{CANCEL_BUTTON}</Button>
            <button
              variant="contained"
              color="primary"
              onClick={saveClick}
              disabled={disablePrimary}
            >
              {SAVE_BUTTON}
            </button>
          </DialogActions>
        </Dialog>
      </TableCell>
    </TableRow>
  );
};

export default AuthorListing;
